import React, { Component } from 'react';
import { Input, Modal, Form, Select, Button, message } from 'antd'
import { getMethod, axiosPost } from '../../../server/index'
import {  getCookie } from '../../../public/utils'
import { get } from 'lodash'
import common from '../../../public/common'
class BindPhoneModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cut_count: 60,
      bindEmailOpen: false,
    }
  }

  formaction = React.createRef()

  componentWillUnmount() {
    let { interval } = this.state
    if (interval) {
      clearInterval(interval)
    }
  }

  // 点击获取验证码
  sendVFcode = () => {
    let flag = true
    let { cut_count } = this.state
    let _phone = get(this.formaction.current.getFieldValue("phone"), "number")
    let phone = _phone ? _phone.trim() : ""
    if (!(/^1\d{10}$/.test(phone))) {
      flag = false
      this.formaction.current.setFields([{
        errors: ["手机号未填写或不正确"],
        name: ["phone", "number"],
        value: _phone,
      }])
    }
    if (cut_count < 30) {
      flag = false
    }
    if (flag) {
      this.getVfCode(phone)
    }
  }

  // 获取验证码-手机号
  getVfCode = async (phone) => {
    console.log("getVfCode")
    let { cut_count } = this.state
    let res = await axiosPost(common.eurekaUrlDic + "/auth/send-verify-code", {
      send_id: phone,
      type: 3,
      sms: true,
    })
    if (get(res, "data.code") == 200) {
      message.success("验证码发送成功，请及时查收")
      let interval = setInterval(() => {
        if (cut_count > 0) {
          cut_count--
        } else {
          cut_count = 30
          clearInterval(interval)
        }
        this.setState({
          interval,
          cut_count
        })
      }, 1000);
    } else {
      message.error('获取验证码失败');
    }
  }
  // 确认绑定
  confirmBind = () => {
    this.formaction.current.validateFields().then(res => {
      let _phone = get(res, "phone.number")
      let _code = get(res, "phone.code")
      let phone = _phone ? _phone.trim() : ""
      let code = _code ? _code.trim() : ""
      axiosPost(common.eurekaUrlDic + "/auth/bind-sms-way", {
        send_id: phone,
        verify_code: code,
        account:getCookie('phone'),
        sms: true,
      }).then(res => {
        if (get(res, "data.code") === 200) {
          message.success("操作成功")
          setTimeout(() => {
            window.location.reload()
          }, 1000);
        } else if (get(res, "data.message")) {
          message.error(get(res, "data.message"))
        }
      })
    })
  }
  render() {
    let { cut_count } = this.state
    return (
      <Modal
        destroyOnClose
        title="绑定手机号"
        open={this.props.open}
        onOk={this.confirmBind}
        onCancel={this.props.onCancel}
      >
        <div>
          <Form ref={this.formaction} requiredMark={false}>
            <Input.Group compact style={{ display: "flex", justifyContent: "flex-start", width: "100%", flexWrap: "wrap" }}>
              <Form.Item
                label="手机号码"
                name={[`phone`, 'area']}
                rules={[{ required: false, }]}
              >
                <Select
                  style={{ width: 100 }}
                  disabled={true}
                  defaultValue={"+86"}
                  options={[{ value: "+86", label: "+86" }]}
                />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: "请输入手机号" }]}
                name={[`phone`, 'number']}
              >
                <Input onChange={() => { console.log() }} style={{ width: 200, }} placeholder="请输入11位手机号" />
              </Form.Item>
            </Input.Group>
            <Input.Group compact style={{ display: "flex", justifyContent: "flex-start", width: "100%", flexWrap: "wrap" }}>
              <Form.Item
                label="验证码"
                name={[`phone`, 'code']}
                rules={[{ required: true, }]}
              >
                <Input style={{ width: 200 }} placeholder="请输入验证码" />
              </Form.Item>
              <Form.Item
                rules={[{ required: false, }]}
              >
                <Button disabled={cut_count < 60} style={{ width: 102 }} onClick={this.sendVFcode} type="primary">{cut_count < 60 ? `${cut_count}s` : "获取验证码"}</Button>
              </Form.Item>
            </Input.Group>
          </Form>
        </div>
      </Modal>
    );
  }
}

export default BindPhoneModal;


// WEBPACK FOOTER //
// ./src/pages/login/components/bindPhone.jsx